import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-board-loading',
  templateUrl: './board-loading.component.html',
  styleUrls: ['./board-loading.component.scss']
})
export class BoardLoadingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
